module.exports = __webpack_public_path__ + "img/logo_satec.185937bb.png";